import React, { useState } from 'react'
import CategoryListCollection from './CategoryListCollection'

export default function RefContainerList2({
  headerText,
  listRef,
  editButton,
  insertButton,
  secondaryContentAction,
}) {
  const [editState, setEditState] = useState(false)
  const editingButton = <i className='material-icons'>clear</i>
  const editToggle = (
    <a className='edit-list-icon' onClick={() => setEditState(!editState)}>
      {editState ? editingButton : editButton}
    </a>
  )
  return (
    <>
      cname RefContainerList2/
      <div className='mt-16'>
        <div className='text-center text-4xl font-bold'>{headerText}</div>
      </div>
      <div className="">
        <div className='flex pl-2'>{editButton}</div>
        <div className='pr-2'>{insertButton}</div>
      </div>
      <ul>
        <CategoryListCollection
          collectionArray={listRef}
        // secondaryContent={editState ? 'delete' : 'keyboard_arrow_right'}
        // secondaryContentAction={
        //   editState ? secondaryContentAction : () => console.log('click')
        // }
        />
      </ul>
    </>
  )
}
